import Ratings from '@components/common/ratings'

export type LearningProcessType = {
  image: string
  title: string
  description: string
}

type Props = {
  learningProcess: LearningProcessType[]
}

const LearningProcess = ({ learningProcess }: Props) => {
  return (
    <div className="relative bg-orange-100">
      <div className="container mx-auto py-6">
        <div className="flex flex-col items-center mt-10 pt-10 px-4 relative  md:mx-4 rounded-2xl">
          <h2 className="pb-4 md:pb-0 pt-3 text-grey font-600 text-center text-2xl md:text-3xl">
            In 3 Simple Steps
          </h2>
          <div className="block md:hidden">
            <Ratings isDarkText />
          </div>
        </div>
        <div className="flex flex-wrap lg:flex-no-wrap justify-center px-4 mb-10">
          {learningProcess.map((whyCodingal, index) => (
            <div className="relative flex" key={index}>
              <div
                className="flex flex-col mx-2 my-6 relative text-center"
                style={{ width: '290px' }}
              >
                <p className="mt-3 mb-3 text-7xl">{whyCodingal.image}</p>
                <h3 className="mt-3 text-2xl font-600">{whyCodingal.title}</h3>
                <p className="mt-3 mb-3 text-lg leading-6">
                  {whyCodingal.description}
                </p>
                <p className="absolute top-0 right-5 bg-red-200 text-white rounded-full w-6 font-600">
                  {index + 1}
                </p>
              </div>
              {index !== learningProcess.length - 1 && (
                <>
                  {index % 2 == 0 ? (
                    <>
                      <div className="lg:mt-12 lg:block hidden -mx-6">
                        <svg
                          width="113"
                          height="55"
                          viewBox="0 0 113 55"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.02075 37.1398C30.2932 14.0605 71.293 11.5603 104.635 24.7837"
                            stroke="#C2B9B2"
                          />
                          <path
                            d="M106 18C107 22 107.769 25.6434 112 28.783C109.407 27.978 104.5 28 99 28.783"
                            stroke="#C2B9B2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="6 6"
                          />
                        </svg>
                      </div>
                      <div
                        className="block md:hidden absolute -bottom-5 right-0 mb-12"
                        style={{
                          transform: 'rotate(116deg)',
                        }}
                      >
                        <svg
                          width="113"
                          height="55"
                          viewBox="0 0 113 55"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.02075 37.1398C30.2932 14.0605 71.293 11.5603 104.635 24.7837"
                            stroke="#C2B9B2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="6 6"
                          />
                          <path
                            d="M106 18C107 22 107.769 25.6434 112 28.783C109.407 27.978 104.5 28 99 28.783"
                            stroke="#C2B9B2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="6 6"
                          />
                        </svg>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="lg:mt-12 lg:block hidden -mx-6">
                        <svg
                          width="115"
                          height="35"
                          viewBox="0 0 115 35"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M102.942 18.5669C72.3639 35.5344 31.7694 29.2627 2 9.25439"
                            stroke="#C2B9B2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="6 6"
                          />
                          <path
                            d="M100.621 12.5639C104.704 13.1343 108.37 13.7854 112.866 11.0376C111.149 13.1402 109.332 17.6989 107.998 23.092"
                            stroke="#C2B9B2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="6 6"
                          />
                        </svg>
                      </div>
                      <div
                        className="block md:hidden absolute -bottom-5 left-0 mb-12"
                        style={{
                          transform: 'rotate(79deg)',
                        }}
                      >
                        <svg
                          width="115"
                          height="35"
                          viewBox="0 0 115 35"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M102.942 18.5669C72.3639 35.5344 31.7694 29.2627 2 9.25439"
                            stroke="#C2B9B2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="6 6"
                          />
                          <path
                            d="M100.621 12.5639C104.704 13.1343 108.37 13.7854 112.866 11.0376C111.149 13.1402 109.332 17.6989 107.998 23.092"
                            stroke="#C2B9B2"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="6 6"
                          />
                        </svg>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default LearningProcess
